import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class BaseEditor extends Vue {
  /**
   * 模型
   */
  @Prop()
  protected model!: IndexObject;


  /**
   * 属性
   */
  @Prop()
  protected props!: IProp[];

  protected dic: IndexObject = {};

  /**
   * 将数组转换为字典
   */
  @Watch("props")
  protected updateDic() {
    if (this.props) {
      this.dic = {};
      for (let iterator of this.props) {
        this.$set(this.dic, iterator.value, iterator);
      }
    }
  }

  /**
   * 根据keys值获取属性
   * @param keys 
   */
  protected getProps(keys: string[]) {
    let props: IProp[] = [];
    for (const key of keys) {
      if (this.dic[key]) {
        props.push(this.dic[key]);
      }
    }
    return props;
  }

  /**
   * 函数创建时的钩子
   */
  created() {
    this.updateDic();
  }
}
